/***
 * @file:
 * @author: linkun.he
 * @Date: 2020-05-22 15:28:15
 */
import { Injectable } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';
import { noop } from './form.utils';
import monitor from './monitor';

@Injectable({
  providedIn: 'root',
})
export abstract class ControlValueAccessorService implements ControlValueAccessor {
  value;
  prop;
  // æ§ä»¶å¼è®¿é®å¨çåè°å ä½ç¬¦
  onTouchedCallback: () => void = noop;
  onChangeCallback: (_: any) => void = noop;
  _changeValue: (fn) => void = noop;
  isFrist = true;
  // æ¯å¦è¢«ç¦ç¨
  isDisabled: boolean;
  // å¤±å»ç¦ç¹
  onBlur() {
    this.onTouchedCallback();
  }

  updateChanges() {
    this.onChangeCallback(this.value);
  }

  // ControlValueAccessorçæ¥å£ï¼ ç¶ç»ä»¶å¼æ´æ°
  writeValue(value: any) {
    this.value = value;
    if (!this.isFrist) {
      monitor.emit('formValueChange', this.prop);
    }
    this._changeValue(value);
  }
  changeValueCallback(fn) {
    this._changeValue = fn;
  }

  // ControlValueAccessorçæ¥å£ï¼ æ¨éå­ç»ä»¶æ´æ°çå¼
  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  // ControlValueAccessorçæ¥å£,è¡¨åæ§ä»¶æ¯å¦è¢«è®¿é®è¿
  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
    this.isFrist = false;
  }

  // è·å¾æ§ä»¶æ¯å¦ç¦ç¨çç¶æ
  setDisabledState(isDisabled: boolean) {
    this.isDisabled = isDisabled;
  }
}
